<template>
  <div class="flex flex-col">
    <p class="mb-3 text-xs leading-tight sm:mb-4 sm:text-sm md:text-base">
      Ajusta cantidades o marca productos sin stock.
    </p>
    <div class="max-h-[350px] flex-1 overflow-y-scroll md:max-h-[450px]">
      <div class="space-y-2 sm:space-y-3">
        <sub-order-modifications-product-adjustment-card
          v-for="product in subOrderProducts"
          :key="product.id"
          :product="product"
          :product-modification="productModifications[product.id]"
          @update:product-modification="handleModificationUpdate"
        />
      </div>
    </div>
    <div
      class="flex shrink-0 flex-col space-y-2 border-t border-gray-100 pt-3 sm:flex-row sm:justify-end sm:space-x-2 sm:space-y-0 sm:pt-6"
    >
      <button
        type="button"
        class="w-full rounded-lg border border-lk-green bg-white px-3 py-2 text-sm font-semibold text-lk-green transition-colors hover:bg-lk-green hover:text-white sm:w-auto"
        @click="emit('next-step')"
      >
        Siguiente
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import SubOrderModificationsProductAdjustmentCard from './sub-order-modifications-product-adjustment-card.vue';

interface SubOrderModificationsProductAdjustmentsProps {
  subOrderProducts: SubOrderProduct[];
  productModifications: Record<number, ProductModification>;
}

interface SubOrderModificationsProductAdjustmentsEmits {
  'modifications-updated': [productModifications: Record<number, ProductModification>];
  'next-step': [];
}

const props = defineProps<SubOrderModificationsProductAdjustmentsProps>();
const emit = defineEmits<SubOrderModificationsProductAdjustmentsEmits>();

function handleModificationUpdate(productId: number, productModification: ProductModification | null) {
  const newProductModifications = { ...props.productModifications };

  if (productModification === null) {
    delete newProductModifications[productId];
  } else {
    newProductModifications[productId] = productModification;
  }

  emit('modifications-updated', newProductModifications);
}
</script>
